module.exports = __webpack_public_path__ + "static/media/Rolling.e81d4bde.gif";